import { FC } from "react";
import { formatDate } from "shared/utils";
import type { SupportTicket } from "../model/types";
import { TicketStatusBadge } from "./TicketStatusBadge";

import styles from "./TicketRow.module.css";

interface Props {
  ticket: SupportTicket;
  onClick: (ticketId: number) => void;
}

export const TicketRow: FC<Props> = ({ ticket, onClick }) => (
  <button
    type="button"
    className={styles.row}
    onClick={() => onClick(ticket.id)}
  >
    <span className={styles.header}>
      <span className={styles.subject}>
        #{ticket.id} {ticket.subject}
      </span>
      <TicketStatusBadge status={ticket.status} />
    </span>
    <span className={styles.date}>
      Updated {formatDate(Date.parse(ticket.updated_at))}
    </span>
  </button>
);
